module.exports = __webpack_public_path__ + "img/data-mining.f2b6d8ca.png";